import { render, staticRenderFns } from "./RiskCreditHeader.vue?vue&type=template&id=3581591f&scoped=true&"
import script from "./RiskCreditHeader.vue?vue&type=script&lang=js&"
export * from "./RiskCreditHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581591f",
  null
  
)

export default component.exports